require('./bootstrap');
// add lazy-load supported
import LazyLoad from "vanilla-lazyload";

let myLazyLoad = new LazyLoad();


document.addEventListener('DOMContentLoaded', () => {

        let hamburger = document.querySelector('.header__burger'),
            menu = document.querySelector('.headmenu'),
            mobClose = document.querySelector('.headmenu__close'),
            body = document.querySelector('body');

        const toggleMenu = () => {
            menu.classList.toggle('show');
            body.classList.toggle('hidden');
        }

        hamburger.addEventListener('click', e => {
            e.stopPropagation();

            toggleMenu();
        });

        document.addEventListener('click', e => {
            let target = e.target;
            let its_menu = target == menu || menu.contains(target);
            let its_hamburger = target == hamburger;
            let menu_is_active = menu.classList.contains('show');

            if (!its_menu && !its_hamburger && menu_is_active) {
                toggleMenu();
            }
        });
        mobClose.addEventListener('click', function (e) {
            menu.classList.remove('show');
            body.classList.remove('hidden');
        })

        let menuLi = document.querySelectorAll('#menu-header_menu li');
        if (menuLi.length < 2) {
            hamburger.classList.add('burger_off');
        }
        _coverTable();
    }
);


jQuery(document).ready(function () {
    jQuery('.menu-btn').click(function () {
        jQuery('#menu-main-menu').slideToggle('fast');
    });
})

function _coverTable() {
    let table = document.querySelectorAll('table');
    for (let i = table.length - 1; i >= 0; i--) {
        let cover = document.createElement('div');
        cover.classList.add('cover-table');
        table[i].parentNode.insertBefore(cover, table[i]);
        cover.appendChild(table[i]);
    }
}


/*!
 * simple-js-slider
 * @author: avakandy
 * @version: 1.0.3
 * Copyright 2017.
 */

(function () {
    'use strict';

    let m_slider = document.getElementById('slider_main'); //id списка слайдера
    //pager_css = 'css/pager.min.css'; //путь к файлу стилей пейджера
    if (m_slider) {
        initSlider(5000, m_slider);
    }//можно передать значение интервала в качестве параметра, например, initSlider(2000) - для запуска слайдера с интервалом в 2с.


    function initSlider(time, curent_slider) {
        let slides = curent_slider.getElementsByTagName('article'), //элементы слайдера
            buttons, //запишем сюда массив кнопок пейджера
            method = {}, //методы
            handle = {}; //переменные

        handle.count = slides.length; //кол-во слайдов
        handle.current = 0; //текущий слайд
        handle.delay = 3000; //интервал смены слайдов по-умолчанию

        method.addPager = function () {//добавим в разметку пейджер и создадим управление прокруткой
            let pager = document.createElement('div');
            pager.className = 'b-pager';
            for (let i = 0; i < handle.count; i++) {
                let item = document.createElement('span');
                item.className = 'b-pager__item';
                item.setAttribute('data-item', i);
                pager.appendChild(item);
                method.clickOnPager(item);//добавим обработку клика по кнопке (вынесем за пределы цикла)
            }
            // method.addPagerStyles();//добавили в head стили пейджера
            curent_slider.appendChild(pager);//добавили кнопки пейджера в слайдер
            buttons = curent_slider.getElementsByClassName('b-pager__item'); //после того как пейджер создан, запишем его элементы в массив
        };

        /*method.addPagerStyles = function(){
            let css = document.createElement('link');
            css.setAttribute('rel', 'stylesheet');
            css.setAttribute('href', pager_css);
            document.getElementsByTagName("head")[0].appendChild(css);
        };*/

        method.clickOnPager = function (el) {//обработка клика по кнопке пейджера
            el.addEventListener('click', function () {
                let data = el.getAttribute('data-item');
                if (data === handle.current) {
                    return false;
                } else {
                    method.goToSlide(data); //переходим на нужный слайд
                }
            });
        };

        method.startSlider = function () {//запуск (перпезапуск)
            addClass(slides[handle.current], 'current');
            addClass(buttons[handle.current], 'current');
            method.requestInterval();//включаем автоматическую смену слайдов
        };

        method.hideSlide = function () {
            removeClass(slides[handle.current], 'current');
            removeClass(buttons[handle.current], 'current');
        };

        method.showSlide = function () {
            addClass(slides[handle.current], 'current');
            addClass(buttons[handle.current], 'current');
        };

        method.nextSlide = function () {
            method.hideSlide();
            handle.current = (handle.current + 1) % handle.count;
            method.showSlide();
        };

        method.goToSlide = function (n) {
            method.pauseSlider();
            method.hideSlide();
            handle.current = n;
            method.startSlider();
        };

        method.requestInterval = function () {//для более точного выполнения, будем вызывать рекурсивно setTimeout вместо setInterval
            handle.timer = setTimeout(function loop() {
                method.nextSlide();
                handle.timer = setTimeout(loop, handle.delay);
            }, handle.delay);
        };

        method.pauseSlider = function () {//остановим автоматическую прокрутку
            clearTimeout(handle.timer);
        };

        method.init = (function () {
            if (!isNaN(time)) {//проверим переданное значение интервала смены слайдов (если есть, если нет - оставим дефолтное)
                handle.delay = Math.round(time);
                if (handle.delay < 1000) handle.delay = 1000;
            }

            //если на странице более чем 1 слайд - запустим
            if (slides.length > 1) {
                method.addPager();
                method.startSlider();
            } else { //иначе просто покажем первый слайд
                addClass(slides[0], 'current');
            }
        })();
    }


    //helpers. Ф-ции добавить/удалить класс плюс fallback для ie9
    function addClass(el, className) {
        if (el.classList)
            el.classList.add(className);
        else
            el.className += ' ' + className;
    }

    function removeClass(el, className) {
        if (el.classList)
            el.classList.remove(className);
        else
            el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
    }
})();

(function () {
    'use strict';
    let win = document.getElementById('wt');
    if (win) {
        winTimer(win);
    }

    function winTimer(el) {
        let default_val = 10000000, minimum_val = 256987, maximum_val = 6000000000, current = 0, min = 0, max = 1,
            min_time = 3000, max_time = 8000, timer = '', time = '', method = {};
        method.init = function () {
            current = parseFloat(localStorage.getItem('winValue'));
            if (!current) {
                method.save(default_val);
            }
            method.show(current);
            time = method.getRandomTime();
            timer = setTimeout(function tick() {
                method.add();
                time = method.getRandomTime();
                timer = setTimeout(tick, time);
            }, time);
        };
        method.save = function (val) {
            try {
                saveToStorage();
            } catch (e) {
                if (e == QUOTA_EXCEEDED_ERR) {
                    localStorage.clear();
                    saveToStorage();
                }
            }

            function saveToStorage() {
                localStorage.setItem('winValue', val);
                current = val;
            }
        };
        method.show = function (val) {
            el.innerHTML = method.numberFormat(val, 2, '.', ',');
        };
        method.add = function () {
            current = parseFloat(localStorage.getItem('winValue')) + Math.round((Math.random() * (max - min) + min) * 100) / 100;
            if (current > maximum_val) {
                current = minimum_val;
            }
            method.save(current);
            method.show(current);
        };
        method.getRandomTime = function () {
            return Math.floor(Math.random() * (max_time - min_time + 1)) + min_time;
        };
        method.numberFormat = function (number, decimals, dec_point, thousands_sep) {
            number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
            let n = !isFinite(+number) ? 0 : +number, prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
                sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
                dec = (typeof dec_point === 'undefined') ? '.' : dec_point, s = '', toFixedFix = function (n, prec) {
                    let k = Math.pow(10, prec);
                    return '' + (Math.round(n * k) / k).toFixed(prec);
                };
            s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
            if (s[0].length > 3) {
                s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
            }
            if ((s[1] || '').length < prec) {
                s[1] = s[1] || '';
                s[1] += new Array(prec - s[1].length + 1).join('0');
            }
            return s.join(dec);
        };
        method.init();
    }
})();

(function () {
    'use strict';
    let Carousel = (function () {
        let method = function (list) {
            this.slider = list;
            this.slides = this.slider.getElementsByTagName('article');
            this.count = this.slides.length;
            this.size = this.slider.getAttribute('data-size');
            this.delay = this.slider.getAttribute('data-time');
            this.mode = this.slider.getAttribute('data-mode');
            this.current = 0;
            this.handle = {};
        };
        method.prototype.init = function () {
            this.handle.isStarted = false;
            if (isNaN(this.size)) {
                this.size = 100;
            }
            if (isNaN(this.delay) || this.delay < 1000) {
                this.delay = 2000;
            }
            if (!(this.mode === 'vertical' || this.mode === 'horizontal')) {
                this.mode = 'vertical';
            }
            let last = this.slides[this.count - 1];
            this.slider.insertBefore(last, this.slides[0]);
            if (this.mode === 'horizontal') {
                this.slider.style.left = -this.size + 'px';
                this.slider.style.width = this.size * this.count + 'px';
            } else {
                this.slider.style.top = -this.size + 'px';
            }
            this.start();
            this.hover();
        };
        method.prototype.start = function () {
            if (!this.handle.isStarted) {
                this.handle.isStarted = true;
                this.handle.timer = setInterval(this.move.bind(this), this.delay);
            }
        };
        method.prototype.stop = function () {
            if (this.handle.isStarted) {
                this.handle.isStarted = false;
                clearTimeout(this.handle.timer);
            }
        };
        method.prototype.hover = function () {
            this.slider.addEventListener('mouseover', function () {
                this.stop();
            }.bind(this));
            this.slider.addEventListener('mouseout', function () {
                this.start();
            }.bind(this));
        };
        method.prototype.move = function () {
            addClass(this.slider, 'moved');
            if (this.mode === 'horizontal') {
                this.slider.style.transform = 'translateX( -' + this.size + 'px)';
            } else {
                this.slider.style.transform = 'translateY( -' + this.size + 'px)';
            }
            setTimeout(this.change.bind(this), 1000);
        };
        method.prototype.change = function () {
            removeClass(this.slider, 'moved');
            this.slider.style.transform = 'none';
            this.slider.appendChild(this.slides[0]);
        };
        return method;
    })();

    function addClass(el, className) {
        if (el.classList) el.classList.add(className); else
            el.className += ' ' + className;
    }

    function removeClass(el, className) {
        if (el.classList) el.classList.remove(className); else
            el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
    }

    let s1 = document.getElementById('slider-players');
    if (s1) {
        let slider1 = new Carousel(s1);
        if (slider1) {
            slider1.init();
        }
    }
    let s2 = document.getElementById('crsl02');
    if (s2) {
        let slider2 = new Carousel(s2);
        if (slider2) {
            slider2.init();
        }
    }
    let s3 = document.getElementById('crsl03');
    if (s3) {
        let slider3 = new Carousel(s3);
        if (slider3) {
            slider3.init();
        }
    }
})();
